import { common, IOHelper, JSONHelper } from '@neo-one/client-common';
import { BaseState } from '@neo-one/client-full-common';
import { createSerializeWire, } from './Serializable';
import { BinaryReader, utils } from './utils';
export class Validator extends BaseState {
    constructor({ version, publicKey, registered = false, votes = utils.ZERO }) {
        super({ version });
        this.equals = utils.equals(Validator, this, (other) => common.ecPointEqual(this.publicKey, other.publicKey));
        this.toKeyString = utils.toKeyString(Validator, () => common.ecPointToString(this.publicKey));
        this.serializeWire = createSerializeWire(this.serializeWireBase.bind(this));
        this.publicKey = publicKey;
        this.registered = registered;
        this.votes = votes;
        this.sizeInternal = utils.lazy(() => IOHelper.sizeOfECPoint(this.publicKey) + IOHelper.sizeOfBoolean + IOHelper.sizeOfFixed8);
    }
    static deserializeWireBase({ reader }) {
        const version = reader.readUInt8();
        const publicKey = reader.readECPoint();
        const registered = reader.readBoolean();
        const votes = reader.readFixed8();
        return new this({ version, publicKey, registered, votes });
    }
    static deserializeWire(options) {
        return this.deserializeWireBase({
            context: options.context,
            reader: new BinaryReader(options.buffer),
        });
    }
    get size() {
        return this.sizeInternal();
    }
    update({ votes = this.votes, registered = this.registered }) {
        return new Validator({
            version: this.version,
            publicKey: this.publicKey,
            registered,
            votes,
        });
    }
    serializeWireBase(writer) {
        writer.writeUInt8(this.version);
        writer.writeECPoint(this.publicKey);
        writer.writeBoolean(this.registered);
        writer.writeFixed8(this.votes);
    }
    serializeJSON(_context) {
        return {
            version: this.version,
            publicKey: JSONHelper.writeECPoint(this.publicKey),
            registered: this.registered,
            votes: JSONHelper.writeFixed8(this.votes),
        };
    }
}

//# sourceMappingURL=Validator.js.map
